module.exports = __webpack_public_path__ + "img/close.0fa71abc.svg";